namespace Areas.ITTask {
    "use strict";


    export function goBack() {
        window.history.back();
    }

    export function gotoListFromForm() {

        var linkInfo = "/ITTask/List/Active/";
            location.href = linkInfo;
    }

    export function gotoEditFromForm() {
        var keyId: any = $('#ITTaskForm').dxForm('instance').option('KeyId');
        if (keyId != null) {
            var linkInfo = "/ITTask/Edit/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }

    export function gotoViewFromForm() {
        var keyId: any = $('#ITTaskForm').dxForm('instance').option('KeyId');
        if (keyId != null) {
            var linkInfo = "/ITTask/View/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }

    export function gotoCreate(e) {
        var linkInfo = "/ITTask/Create/Index/";
            location.href = linkInfo;
    }

    export function gotoEdit() {
        var dataGrid = $('#ITTaskGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/ITTask/Edit/Index/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function gotoView() {
        var dataGrid = $('#ITTaskGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/ITTask/View/Index/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function viewLink(cellElement, cellInfo) {
        var fieldData = cellInfo.data.taskId;
        var linkInfo = "<a href= '/ITTask/View/Index/" + String(fieldData) + "' target=_blank >View</a>"
        cellElement.html(linkInfo);
    }

}
